import { Component, ViewEncapsulation, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbClientsService } from '@irb/irb-clients/irb-clients.service';
import { IrbClientsEvents, IrbAppEvents, IrbEditorsEvents } from '@irb-common/events';
import { IrbEditorsService } from '@irb/irb-editors/irb-editors.service';
import { UtilityService } from '@irb-common/services/utility.service';

@Component({ standalone: false,
  selector: 'irb-import-extra-cash-settings-dialog',
  templateUrl: './import-extra-cash-settings-dialog.component.html',
  styleUrls: ['./import-extra-cash-settings-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportExtraCashSettingsDialogComponent implements OnInit {
  file: any;
  hasFile: boolean = false;
  isValidFile: boolean = false;
  invalidFileErrorHeader: string;
  invalidFileErrorMessage: string;
  errorMessage: string;

  constructor(
    public dialogRef: MatDialogRef<ImportExtraCashSettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public analysisId: number,
    public as: AppService,
    public cs: IrbClientsService,
    private ies: IrbEditorsService,
    private util: UtilityService
  ) { 
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onFileChange(event: any) {
    this.errorMessage = null;
    this.file = event.target.files[0];
    this.hasFile = this.isValidFile = true;
    if (!this.file.name.endsWith('.csv')) {
      this.isValidFile = false;
      this.invalidFileErrorHeader = "Invalid file format.";
      this.invalidFileErrorMessage = "Extension type must be \".csv\"";
    }
    if (this.as.maxFileUploadSizeExceeded(this.file)) {
      this.triggerMaxFileUploadSizeExceededError();
    }
  }

  private triggerMaxFileUploadSizeExceededError() {
    this.isValidFile = false;
    this.invalidFileErrorHeader = "Invalid file size.";
    this.invalidFileErrorMessage = "File size exceeds 50MB limit.";
  }

  submitFile() {
    const f = new FormData();
    f.append('ImportAccountCash0', this.file, this.file.name);
    this.ies.importExtraCashRebal(f,this.analysisId).subscribe({
        next: (res: string) => {
          if (res.includes('Max upload size exceeded')) {
            this.triggerMaxFileUploadSizeExceededError();
          } else {
            const r: any = res.indexOf('<textarea>') >= 0 ? JSON.parse(res.substring(res.indexOf('<textarea>') + 10, res.indexOf('</textarea>'))): JSON.parse(res);
            if (r?.responseStatus && r?.responseStatus === 'EXCEPTION') {
              this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'error',
                summary: 'Import Accounts to Portfolio',
                detail: ' An error occurred processing your request.'
              });
              return;
            }
            let response;
            let responseData;
            if (r.responseData) {
              responseData = r.responseData;
            }
            if (r.responseUtilityMap) { // sa 2024-07-18 todo: raise a bug to make response consistent
              response = r.responseUtilityMap;
            } else {
              response = r;
            }
            if (response.ImproperAmount && response.ImproperAmount.length > 0) {
              this.errorMessage = 'Your .csv file includes ' +response.ImproperAmount.length + ' account(s) with improper amount. ' +
                'Remove these accounts and reimport the file.';
            } else if (response.SMAAccounts && response.SMAAccounts.length > 0) {
              this.errorMessage = 'Your .csv file includes ' +response.SMAAccounts.length + ' SMA account(s). ' +
                'Extra cash cannot be added to SMA accounts. Remove these accounts and reimport the file.';
            } else if (response.UndefinedAccounts && response.UndefinedAccounts.length > 0) {
              this.errorMessage = 'Your .csv file includes ' +response.UndefinedAccounts.length + ' undefined account(s). ' +
                'Remove these accounts and reimport the file.';
            } else if (response.ErrorRows && response.ErrorRows.length > 0) {
              this.errorMessage = 'Your .csv file includes ' +response.ErrorRows.length + ' account(s) with errors. ' +
                'Remove these accounts and reimport the file.';
            } else if (r.responseData && r.responseData.analysisPortDtoList && r.responseData.analysisPortDtoList.length !== 0) {
              this.as.fireEvent(IrbEditorsEvents.REFRESH_INCLUDED_PORTFOLIO_GRID, r);
              this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'success',
                summary: 'Extra cash settings',
                detail: "Successfully imported to " + r.responseData.analysisPortDtoList.length + " portfolio(s)"
              });
              this.close();
            } else {
              if (response.message) {
                this.errorMessage = response.message;
                return;
              }

              this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'warn',
                summary: 'Import Accounts to Portfolio',
                detail: 'The import completed without any assignments being imported.'
              });
              this.close();
            }

          }
        }, error: () => {}
    });
  }
}
